import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const LightBulb = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5417 2.56604C8.5417 2.25342 8.28828 2 7.97566 2C7.66305 2 7.40962 2.25342 7.40962 2.56604V3.54818C7.40962 3.8608 7.66305 4.11422 7.97566 4.11422C8.28828 4.11422 8.5417 3.8608 8.5417 3.54818V2.56604Z"
        fill="currentColor"
      />
      <path
        d="M13.4776 5.47399C13.7479 5.31687 13.8396 4.9704 13.6824 4.70014C13.5253 4.42988 13.1789 4.33817 12.9086 4.49529L11.8666 5.10111C11.5963 5.25823 11.5046 5.60469 11.6617 5.87495C11.8188 6.14521 12.1653 6.23693 12.4355 6.07981L13.4776 5.47399Z"
        fill="currentColor"
      />
      <path
        d="M3.1045 4.50319C2.8386 4.33879 2.48978 4.42108 2.32539 4.68698C2.16099 4.95287 2.24328 5.3017 2.50918 5.46609L3.48906 6.07191C3.75496 6.2363 4.10378 6.15402 4.26817 5.88812C4.43257 5.62222 4.35028 5.2734 4.08438 5.10901L3.1045 4.50319Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.04054 4.98784C6.6949 4.98784 5.54584 5.64344 4.95808 6.63861C4.3588 7.6533 4.38353 8.9558 5.26574 10.1103C5.67619 10.6474 5.77576 11.0584 5.80457 11.3497C5.85318 11.8412 6.24966 12.3124 6.83572 12.3124H9.05594C9.63779 12.3124 10.0164 11.8523 10.1134 11.4218C10.2357 10.8788 10.6088 10.3617 10.802 10.1202C12.4278 8.08803 10.9886 4.98784 8.04054 4.98784ZM6.16525 9.42289C5.5522 8.62066 5.57701 7.81681 5.93284 7.21432C6.3002 6.59232 7.06129 6.11992 8.04054 6.11992C10.1109 6.11992 10.9065 8.17742 9.918 9.41298C9.70781 9.67571 9.19145 10.363 9.009 11.1731C9.00846 11.1755 9.00775 11.1779 9.00691 11.1803H6.92488C6.86856 10.6999 6.68829 10.1074 6.16525 9.42289Z"
        fill="currentColor"
      />
      <path
        d="M6.88818 12.8679C6.57556 12.8679 6.32214 13.1213 6.32214 13.434C6.32214 13.7466 6.57556 14 6.88818 14H8.93196C9.24458 14 9.498 13.7466 9.498 13.434C9.498 13.1213 9.24458 12.8679 8.93196 12.8679H6.88818Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default LightBulb;
